<template>
	<div>
		<div class="row text-end">
			<help helpId="step4_help" title="Foglalás megerősítése"
				text="Tekintse át a foglalás adatait majd a foglalás gombra kattintva küldje el a foglalást vagy lépjen vissza szerkeszteni az adatokat">
			</help>
		</div>
		<div class="row">
			<div class="col-md-6">
				<h4>Foglalás Adatai</h4>
				<table class="table table-bordered" v-if="selected_guesthouse && filled_rooms">
					<tbody>
						<tr>
							<th>Választott üdülő</th>
							<td>{{ selected_guesthouse.name }}</td>
						</tr>
						<tr>
							<th>Érkezés</th>
							<td>{{ arrive_at }}</td>
						</tr>
						<tr>
							<th>Távozás</th>
							<td>{{ leave_at }}</td>
						</tr>
						<tr>
							<th :rowspan="filled_rooms.length + 1">Választott szobák</th>
							<td class="d-none"></td>
						</tr>
						<tr v-for="(room, id) in filled_rooms" :key="id">
							<td>{{ room.name }} ({{ room.users.length }} ágyas)</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col-md-6">
				<h4>Tag Adatai</h4>
				<table class="table table-bordered" v-if="user">
					<tbody>
						<tr>
							<th>Azonosító</th>
							<td>{{ user.details.membership_id }}</td>
						</tr>
						<tr>
							<th>Név</th>
							<td>{{ user.name }}</td>
						</tr>
						<tr>
							<th>Lakcím</th>
							<td>{{ user.details.postal_code }} {{ user.details.city }}, {{ user.details.street_address
								}}
							</td>
						</tr>
						<tr>
							<th>Telefon</th>
							<td>{{ user.details.phone }}</td>
						</tr>
						<tr>
							<th>E-mail</th>
							<td>{{ user.email }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<h4>Szobák és vendégek</h4>
		<table class="table table-bordered" v-if="filled_rooms && selected_guesthouse">
			<thead>
				<tr>
					<th>Szoba</th>
					<th>Vendég</th>
					<th class="text-end">Szállásdíj</th>
				</tr>
			</thead>
			<tbody v-for="(room, room_id) in filled_rooms" :key="room_id">
				<tr v-if="room.users.length > 1">
					<td :rowspan="room.users.filter(u => u.name).length + 1">{{ room.name }}</td>
					<td class="d-none"></td>
					<td class="d-none"></td>
				</tr>
				<tr v-for="(user, id) in room.users.filter(u => u.name)" :key="id">
					<td v-if="room.users.length == 1">{{ room.name }}</td>
					<td>{{ user.name }}</td>
					<td class="text-end" v-if="selected_guesthouse.apartment == 0">
						<span v-for="(price, p_id) in getPricesForGuestCategory(user.guest_category_id)" :key="p_id">
							<span v-if="p_id > 0"> + </span>
							{{ price.quantity }} x <b>{{ price.price.toLocaleString('hu-HU') }} Ft</b>
						</span>
					</td>
					<td class="text-end" v-else-if="id == 0" :rowspan="room.users.filter(u => u.name).length">{{
					selected_guesthouse.prices
				}}
						Ft</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<th>Összesített ár</th>
					<th class="text-end">{{ num_of_nights }} éjszaka</th>
					<th class="text-end" v-if="selected_guesthouse.apartment == 0">
						{{ total_price.toLocaleString('hu-HU') }}
						Ft
					</th>
					<th class="text-end" v-else>
						{{ parseInt(selected_guesthouse.prices) * num_of_nights / 7 * filled_rooms.length }}
						Ft
					</th>
				</tr>
				<tr v-if="model.nonRefundable">
					<th>10% kedvezmény</th>
					<th class="text-end"></th>
					<th class="text-end">{{ numberWithSpaces(discountAmount) }} Ft</th>
				</tr>
			</tfoot>
		</table>
		<div class="row" v-if="filled_rooms && selected_guesthouse">
			<div class="col-md-6 offset-md-6 col-lg-4 offset-lg-8 border-start">
				<ul style="list-style-type: none;">
					<!--<li v-for="(room, r_id) in filled_rooms" :key="r_id">
						<h6>{{ room.name }}</h6>
						<ul style="list-style-type: none;">
							<li v-for="(user, u_id) in room.users.filter(u => u.name)" :key="u_id">
								<b>{{ user.name }}</b>
								<i v-if="selected_guesthouse.apartment == 0"> - {{ num_of_nights }} *
									{{ selected_guesthouse.prices.find(p => p.guest_category_id ==
										user.guest_category_id).value }} Ft</i>
								<i v-else-if="u_id == 0"> - {{ num_of_nights / 7 }} * {{ selected_guesthouse.prices }}
									Ft</i>
							</li>
						</ul>
					</li>-->
					<li v-if="(num_of_nights > 2 || loggedInUser.role_id == 1) && settingCancellableActive">
						<div class="form-check form-switch mt-2">
							<input class="form-check-input" type="checkbox" id="nonRefundableSwitch" @change="setNonRefundable($event.target.checked)">
							<label class="form-check-label" for="nonRefundableSwitch">Nem lemondható</label>
						</div>
					</li>
					<li v-if="!model.nonRefundable">
						<form @submit.prevent="checkCouponCode()" v-if="!coupon_discount">
							<div class="input-group input-group-sm mt-2" style="max-width:200px;">
								<input type="text" class="form-control form-control-sm" placeholder="kuponkód"
									v-model="coupon_code" required :class="{ 'is-invalid': coupon_error }" />
								<button type="button" class="input-group-text bg-primary text-white"
									style="cursor: pointer;"
									:class="{ 'disabled': coupon_code == null || coupon_code.length == 0 }"
									@click="checkCouponCode"
									:disabled="coupon_code == null || coupon_code.length == 0">Beváltás</button>
							</div>
							<div class="invalid-feedback d-block" v-if="coupon_error">
								{{ coupon_error }}
							</div>
						</form>
						<span class="mt-1" v-else>
							Kupon kedvezmény:
							<ul style="list-style-type: none;" class="mt-1">
								<li>
									<b class="badge bg-danger rounded-pill">{{ coupon_code }}</b><i class="text-red"> -
										{{ coupon_discount }} {{ coupon_discount_type == 'fixed' ? 'Ft' : '%' }} </i>
									<button class="btn btn-xs btn-link text-red" title="kupon törlése"
										@click="couponReset()"><i class="fa fa-times"></i></button>
								</li>
							</ul>
						</span>
					</li>
				</ul>
				<table class="w-100">
					<tr>
						<td class="align-middle">
							<h1>Fizetendő:</h1>
						</td>
						<td class="align-middle text-end">
							<b class="rounded-pill text-white bg-primary px-2 h1"
								v-if="selected_guesthouse.apartment == 0">
								{{ numberWithSpaces(getDiscounted(total_price)) }}
								Ft
							</b>
							<b class="rounded-pill text-white bg-primary px-2 h1" v-else>
								{{ numberWithSpaces(getDiscounted(parseInt(selected_guesthouse.prices) * (num_of_nights
					/ 7)
					*
					filled_rooms.length)) }}
								Ft
							</b>
						</td>
					</tr>
				</table>
			</div>
		</div>
		<form @submit.prevent="validate">
			<button class="d-none" type="submit" ref="submitter"></button>
		</form>
	</div>
</template>

<script>
import Setting from '../../apis/Setting';
import Coupon from '../../apis/Coupon';
import Booking from '../../apis/Booking';
import Price from '../../apis/Price';
import moment from 'moment';
export default {
	data() {
		return {
			settings: null,
			coupon_code: null,
			coupon_discount: false,
			coupon_discount_type: false,
			coupon_error: false,
			model: {
				nonRefundable: false,
			},
			loading: true,
			prices: false,
			temporaryCouponObject: null,
		}
	},
	computed: {
		selected_guesthouse() {
			return this.$store.state.selected_guesthouse;
		},
		filled_rooms() {
			return this.$store.state.filled_rooms;
		},
		persons() {
			return this.filled_rooms.reduce(function(accumulator, room) {
				var validGuests = room.users.filter(function(guest) {
					return guest.name !== null && guest.name.length !== 0;
				});
				// Add the count of valid guests to the accumulator
				return accumulator + validGuests.length;
			}, 0);
		},
		user() {
			return this.$store.state.wizard_user;
		},
		loggedInUser() {
			return this.$store.state.user;
		},
		arrive_at() {
			return this.$store.state.arrive_at;
		},
		leave_at() {
			return this.$store.state.leave_at;
		},
		num_of_nights() {
			return moment(this.leave_at).diff(moment(this.arrive_at), 'days')
		},
		total_price() {
			if (this.prices && this.selected_guesthouse && this.selected_guesthouse.apartment == 0) {
				return this.filled_rooms.map(f => f.users.filter(u => u.guest_category_id != null)).flat().map(u => u.guest_category_id).reduce((total, gci) => {
					return total + Object.values(this.prices).reduce((sum, date) => {
						return sum + date.find(d => d.guest_category_id == gci).price
					}, 0)
				}, 0);
			} else {
				return 0;
			}
		},
		discountAmount() {
			if (this.model.nonRefundable) {
				return this.total_price * 0.1;
			} else {
				return 0;
			}
		},
		settingCancellableActive() {
			if (this.settings) {
				const setting = this.settings.find(s => s.label === 'cancellation_active');
				return setting && setting.value == 1;
			} else {
				return false;
			}
		},

	},
	created() {
		Setting.index()
			.then(response => {
				this.settings = response.data;
			}).catch(() => {
				this.settings = []
			})
		
			
		},
	mounted(){			
		this.$emit('nonRefundable', false);
	},
	watch: {
		selected_guesthouse(val) {
			if (val) {
				this.getPrices();
			}
		},
		arrive_at(val) {
			if (val) {
				this.getPrices();
			}
		},
		user(val) {
			if (val) {
				this.getPrices();
			}
		},
		filled_rooms(val) {
			if (val) {
				this.getPrices();
			}
		},

	},
	methods: {

		getPricesForGuestCategory(guestCategoryId) {
			const pricesArray = Object.values(this.prices)
				.reduce((arr, dateArray) => arr.concat(dateArray), []) // Flatten the array of arrays
				.filter(item => item.guest_category_id === guestCategoryId)
				.reduce((map, item) => {
					const { price } = item;
					map.set(price, (map.get(price) || 0) + 1);
					return map;
				}, new Map());

			return Array.from(pricesArray, ([price, quantity]) => ({ price, quantity }));
		},
		getPrices() {
			if (this.selected_guesthouse && this.arrive_at && this.filled_rooms) {
				Price.getPrices({ id: this.selected_guesthouse.id, arrive_at: this.arrive_at, user_id: this.user.id })
					.then(response => {
						this.$store.commit('updateSelectedGuesthousePrices', response.data);
					});
				if (this.selected_guesthouse.apartment == 0) {
					Price.getGuestCategoryPrices({
						guesthouse_id: this.selected_guesthouse.id,
						arrive_at: this.arrive_at,
						leave_at: this.leave_at,
						guest_category_ids: [...new Set(this.filled_rooms.map(fr => fr.users.map(u => u.guest_category_id)).flat().filter(gc => gc != null))]
					}).then(response => {
						this.prices = response.data;
					});
				}
			}
		},
		restart() {
			this.coupon_code = null;
			this.coupon_discount = false;
			this.coupon_discount_type = false;
			this.model.nonRefundable = false;
		},
		getDiscounted(num) {
			if (this.coupon_discount_type == 'fixed') {
				if (num - this.coupon_discount <= 0) {
					num = 0;
				} else {
					num = num - this.coupon_discount;
				}
			}
			else if (this.coupon_discount_type == 'percent') {
				num = num * ((100 - this.coupon_discount) / 100);
			}

			if (this.model.nonRefundable) {
				num *= 0.9; // Subtract 10% if nonRefundable is true
			}


			return num;
		},
		setNonRefundable(value) {
			if (value) {
				this.$set(this.model, 'nonRefundable', true);
				this.couponReset({saveTemporary: true});
			} else {
				this.$set(this.model, 'nonRefundable', false);
				if (this.temporaryCouponObject) {
					this.coupon_code = this.temporaryCouponObject.coupon_code;
					this.coupon_discount_type = this.temporaryCouponObject.coupon_discount_type;
					this.coupon_discount = this.temporaryCouponObject.coupon_discount;
					//this.checkCouponCode();
				}
			}
			this.$emit('nonRefundable', value);

		},
		checkCouponCode() {
			Booking.validateCoupon({
				name: this.coupon_code,
				arrive_at: this.arrive_at,
				leave_at: this.leave_at,
				persons: this.persons,
				guesthouse_id: this.selected_guesthouse.id
			})
				.then(response => {
					if (response.data) {
						this.coupon_error = false;
						this.$emit('coupon-validated', this.coupon_code);
						this.coupon_discount_type = response.data.discount_type;
						this.coupon_discount = response.data.value;
					} else {
						this.coupon_error = "Érvénytelen kuponkód"
					}
				});
		},
		couponReset(options) {
			if (options && options.saveTemporary) {
				this.temporaryCouponObject = {
					coupon_code: this.coupon_code,
					coupon_discount_type: this.coupon_discount_type,
					coupon_discount: this.coupon_discount
				}
			}
			this.coupon_code = null;
			this.coupon_discount_type = false;
			this.coupon_discount = false;
			this.$emit('coupon-deleted');
		},
		numberWithSpaces(number) {
			return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
		},
		validate() {
			this.$emit('validated', this.model);
		},
		submitForm() {
			this.$refs.submitter.click();
		},
		queryAvailableCoupons() {
			Coupon.available({
				arrive_at: this.arrive_at,
				leave_at: this.leave_at,
				persons: this.persons,
				guesthouse_id: this.selected_guesthouse.id
			}).then(response => {
				if (response.data) {
					this.coupon_error = false;
					this.coupon_code = response.data.coupon_code;
					this.coupon_discount_type = response.data.discount_type;
					this.coupon_discount = response.data.value;
					this.$emit('coupon-validated', this.coupon_code);
				}
				else{
					this.coupon_error = false;
					this.coupon_code = '';
					this.coupon_discount_type = false;
					this.coupon_discount = false;
					this.$emit('coupon-validated', this.coupon_code);
				}
			});
		}
	}

}
</script>
<style>
.disabled {
	opacity: 0.5
}
</style>
